import getQueryParam from './getQueryParam';
var getLanguageFromStorage = function () {
    var availableLanguages = ['en', 'es'];
    var languageFromParam = getQueryParam('lang');
    var languageFromStorage = localStorage.getItem('language');
    if (availableLanguages.includes(languageFromParam)) {
        return languageFromParam;
    }
    if (availableLanguages.includes(languageFromStorage)) {
        return languageFromStorage;
    }
    return 'en';
};
export default getLanguageFromStorage;
